export default {
  首页: "Rumah",
  资产: "Aktiva",
  币币: "Mata uang",
  快捷买币: "Beli koin dengan cepat",
  "支持多种方式购买，购买更简单":
    "Mendukung berbagai cara untuk membeli, membeli lebih sederhana",
  语言设置: "pengaturan bahasa",
  确认恢复: "Konfirmasi pemulihan",
  "输入邮箱，方便我们联系您":
    "Masukkan email Anda agar kami dapat menghubungi Anda",
  划转: "Transfer",
  行情: "Kutipan",
  "24H成交": "Transaksi 24 jam",
  累计收益: "Pendapatan kumulatif",
  充值时间: "Waktu isi ulang",
  到期时间: "Tanggal kadaluarsa",
  数量: "Kuantitas",
  操作: "Beroperasi",
  资产信息: "Informasi Aset",
  复制地址: "Salin alamat",
  链名称: "Nama rantai",
  充值地址: "Alamat isi ulang",
  收款地址: "Alamat Pembayaran",
  账单: "Tagihan",
  提现金额: "Jumlah penarikan",
  接收地址: "Alamat penerima",
  交易密码: "kata sandi transaksi",
  提现全部: "Tarik semua",
  保存图片: "Simpan gambar",
  输入您的交易密码: "Masukkan kata sandi transaksi Anda",
  确定: "Tentu",
  地址: "Alamat",
  注册时间: "Waktu pendaftaran",
  取消: "Membatalkan",
  是否划转: "Apakah akan mentransfer",
  登录: "Gabung",
  我的地址: "Alamat saya",
  登录密码和交易密码: "Kata sandi masuk dan kata sandi transaksi",
  注册: "Daftar",
  密码: "Kata sandi",
  设置密码: "Atur kata sandi",
  重复密码: "Ulangi kata kunci",
  新密码: "Kata sandi baru",
  确认新密码: "Konfirmasi kata sandi baru",
  充值: "Isi ulang",
  充值货币: "Mata uang top-up",
  合约账户充值: "Isi ulang akun kontrak",
  账户充值: "Isi ulang akun",
  其他: "Lainnya",
  我的邀请码: "Kode undangan saya",
  提现: "Menarik",
  客服: "Pelayanan pelanggan",
  持有详情: "Memegang rincian",
  请输入内容: "Silakan masukkan konten",
  邀请好友来领取奖励: "Undang teman untuk menerima hadiah",
  复制链接: "Salin tautan",
  重复设置新的密码: "Ulangi pengaturan kata sandi baru",
  保存: "Menyimpan",
  我的: "Milikku",
  "邮箱/手机号": "Email/Nomor Ponsel",
  备注: "Komentar",
  地址管理: "Manajemen alamat",
  我的团队: "Kelompok ku",
  联系我们: "Hubungi kami",
  竭诚为您服务: "Hormat kami melayani Anda",
  提取收益: "Pendapatan penarikan",
  带给我的收益: "Keuntungan saya",
  添加: "Tambahkan",
  名称: "Nama",
  添加地址: "Tambahkan alamat",
  修改地址: "Ubah alamat",
  可提现: "Dapat ditarik",
  安全中心: "Pusat keamanan",
  收益划转: "Transfer pendapatan",
  通知中心: "Pusat Pemberitahuan",
  "累计收益:": "Penghasilan Kumulatif:",
  注册用户: "Pengguna terdaftar",
  奖励规则: "Aturan Hadiah",
  帮助反馈: "Bantuan umpan balik",
  邀请好友: "Mengundang teman-teman",
  恢复身份: "Mengembalikan identitas",
  选择语言: "Pilih bahasa",
  设置新的密码: "Atur kata sandi baru",
  暂无活动: "Belum ada aktivitas",
  "月增长量(+)": "Pertumbuhan Bulanan (+)",
  可提取: "Dapat diekstraksi",
  反馈类型: "Jenis umpan balik",
  赠送: "Memberikan",
  已经复制: "Telah disalin",
  保存成功: "Berhasil disimpan",
  划转成功: "Transfer sukses",
  过期: "Kedaluwarsa",
  提交成功: "Berhasil dikirimkan",
  "服务器繁忙，稍后在试": "Server sibuk, coba nanti",
  全部: "Semua",
  一级: "Tingkat 1",
  二级: "Sekunder",
  三级: "Tingkat 3",
  级: "Kelas",
  删除成功: "Berhasil dihapus",
  选择地址: "Pilih alamat",
  不再提醒: "Tidak ada lagi pengingat",
  "最小充值金额：": "Jumlah isi ulang minimum:",
  选择币种: "Pilih Mata Uang",
  输入投资金额: "Masukkan jumlah investasi",
  输入账户密码: "Masukkan kata sandi akun",
  投资: "Menginvestasikan",
  订单编号: "Jumlah order",
  投资周期: "Siklus investasi",
  投资资金: "Dana investasi",
  投资时间: "Waktu investasi",
  状态: "Negara",
  投资中: "Di bawah investasi",
  已到期: "Kadaluarsa",
  暂无数据: "Tidak ada data",
  转入: "Transfer masuk",
  邮箱: "Surat",
  请输入邮箱: "Silahkan masukan email anda",
  请输入格式正确的邮箱: "Silakan isi alamat email",
  请输入验证码: "Silahkan masukkan kode verifikasi",
  获取验证码: "Dapatkan kode verifikasi",
  请输入邀请码: "Silakan masukkan kode undangan",
  今天: "Hari ini",
  昨天: "Kemarin",
  最近七天: "Tujuh hari terakhir",
  邀请: "Mengundang",
  购买数量: "Jumlah pembelian",
  产品详情: "Rincian Produk",
  币种: "Mata uang",
  利息币种: "Mata uang bunga",
  理财类型: "Jenis keuangan",
  产品费率: "Tarif produk",
  进行中: "Pengolahan",
  每天: "Setiap hari",
  请输入搜索关键词: "Silakan masukkan kata kunci pencarian",
  通知: "Melihat",
  查看更多: "lihat lebih banyak",
  理财宝: "Harta kekayaan",
  周期: "Siklus",
  年利率: "April",
  更多产品: "Lebih banyak produk",
  灵活存取: "Akses fleksibel",
  稳定收益: "Pendapatan stabil",
  合约指南: "Pedoman Kontrak",
  资金划转出: "Transfer dana keluar",
  矿池收益: "Pendapatan kolam penambangan",
  提现手续费: "Biaya penarikan",
  冻结资金: "Membekukan dana",
  解冻资金: "Mencairkan dana",
  闪兑支出: "Belanja kilat",
  闪兑收入: "Pendapatan pertukaran kilat",
  闪兑手续费: "Biaya pertukaran flash",
  合约支出: "Pengeluaran kontrak",
  合约收入: "Pendapatan kontrak",
  输入的金额不可大于可用金额:
    "Jumlah yang dimasukkan tidak boleh lebih besar dari jumlah yang tersedia",
  全部兑换成功: "Semua berhasil ditebus",
  返回: "Kembali",
  查看历史: "Lihat Sejarah",
  闪兑历史: "Sejarah kilat",
  支付: "Membayar",
  获取: "Memperoleh",
  时间: "Waktu",
  手续费: "Biaya penanganan",
  折扣: "Diskon",
  价格: "Harga",
  逐仓: "Posisi terisolasi",
  全仓: "Gudang penuh",
  市价委托: "pesanan pasar",
  限价委托: "Batasi pesanan",
  请输入本金: "Silakan masukkan kepala sekolah",
  请输入价格: "Silakan masukkan harga",
  "可做空/做多": "Bisa pendek/panjang",
  设置止盈止损: "Tetapkan Take Profit dan Stop Loss",
  止盈价: "Ambil Untung Harga",
  止损价: "Hentikan harga",
  成本: "Biaya",
  做多: "Pergi lama",
  做空: "Pendek",
  仓位信息: "Informasi posisi",
  一键平仓: "Penutupan sekali klik",
  永续: "Berkelanjutan",
  浮动盈亏: "Keuntungan dan kerugian mengambang",
  平仓: "Tutup posisi",
  反向开仓: "Pembukaan terbalik",
  一键撤销: "Batalkan sekali klik",
  倍杠杆: "Leverage ganda",
  执行价格: "Harga kesepakatan",
  委托数量: "Jumlah pesanan",
  保证金: "Batas",
  成交价: "Harga akhir",
  创建时间: "Waktu penciptaan",
  撤销: "Menarik kembali",
  合约市场: "Pasar kontrak",
  交易方向: "Arah perdagangan",
  委托价格: "Harga pesanan",
  委托金额: "Jumlah komisi",
  资金费率: "Tingkat pendanaan",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Biaya berulang yang dibayarkan oleh pedagang panjang dan pendek, diselesaikan setiap 8 jam.",
  "资金费率为正，多方向空方支付资金费用。":
    "Tingkat pendanaan positif, dan sisi panjang membayar sisi pendek biaya pendanaan.",
  "资金费率为负，空方向多方支付资金费用。":
    "Tingkat pendanaan negatif, dan sisi pendek membayar biaya pendanaan kepada banyak pihak.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Apakah Anda yakin ingin membuka posisi secara terbalik? Posisi pembukaan terbalik akan dibeli dengan posisi berlawanan saat ini",
  "仓位止盈/止损": "Posisi Ambil Untung/Hentikan Kerugian",
  合约名称: "Nama kontrak",
  开仓价格: "Harga pembukaan",
  指数价格: "Harga indeks",
  止盈设置: "Ambil Pengaturan Untung",
  请输入止盈价: "Silakan masukkan harga take profit",
  "当指数价格触达*时，将会触发委托平仓":
    "Saat harga indeks menyentuh {0}, order akan terpicu untuk menutup posisi",
  预计盈亏: "Perkiraan untung dan rugi",
  当前仓位: "Posisi saat ini",
  平仓金额: "Jumlah likuidasi",
  仓位模式: "Modus Posisi",
  全仓模式: "Mode gudang penuh",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    " Semua dana yang tersedia di akun kontrak dianggap sebagai margin yang tersedia. Ketika kerugian posisi melebihi saldo akun, posisi akan dilikuidasi dansemua margin dan posisi akan hilang. Harap dicatat bahwa",
  逐仓模式: "Mode margin terisolasi",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    " Ini akan menyebabkan sejumlah margin tertentu dalam akun kontrak dialokasikan ke posisi tersebut. Jika kerugian margin turun di bawah level marginpemeliharaan, posisi dilikuidasi. Dalam mode posisi terisolasi, Anda dapat menambah dan mengurangi margin untuk posisi ini.",
  "是否撤销？": "Apakah dicabut?",
  "是否一键撤销？": "Apakah ini membatalkan satu klik?",
  "是否一键平仓？": "Apakah akan menutup posisi dengan sekali klik?",
  持仓保证金: "Margin posisi",
  风险率: "Tingkat risiko",
  未实现盈亏: "Keuntungan dan kerugian yang belum direalisasi",
  可用保证金: "Margin bebas",
  净值: "Kekayaan bersih",
  账户余额: "Saldo rekening",
  合约计算器: "Kalkulator kontrak",
  交易记录: "Catatan transaksi",
  "*倍杠杆": "{num} x",
  "平仓盈亏：": "Penutupan untung dan rugi:",
  时间筛选: "Filter waktu",
  仓位类型: "Tipe Posisi",
  订单状态: "Status pemesanan",
  订单类型: "Jenis pesanan",
  平仓价格: "Harga penutup",
  持仓数量: "Jumlah posisi",
  "手续费(%)": "Biaya penanganan (%)",
  平仓时间: "Waktu tutup",
  平仓类型: "Jenis penutupan",
  手动平仓: "Tutup posisi secara manual",
  强制平仓: "Likuidasi paksa",
  近1天: "Hari terakhir",
  近7天: "7 hari terakhir",
  近30天: "30 hari terakhir",
  近180天: "180 hari terakhir",
  持仓: "Posisi",
  已取消: "Dibatalkan",
  分时: "Berbagi waktu",
  "24H额(USDT)": "Jumlah 24 jam (USDT)",
  "24H低": "24 jam rendah",
  "24H量(BTC)": "Volume 24 Jam (BTC)",
  "24H高": "Tinggi 24 jam",
  "10秒": "10 detik",
  "30秒": "30 detik",
  "1分": "1 poin",
  "3分": "3 poin",
  "5分": "5 poin",
  "30分": "30 poin",
  "1小时": "1 jam",
  "4小时": "4 jam",
  "8小时": "8 jam",
  "1天": "1 hari",
  "1周": "1 minggu",
  "1月": "Januari",
  单向持仓: "Posisi satu arah",
  杠杆: "Tuas",
  仓位: "Posisi",
  计算结果: "Hasil perhitungan",
  盈亏: "Laba rugi",
  收益率: "Tingkat pengembalian",
  计算结果仅供参考: "Hasil perhitungan hanya untuk referensi",
  成交后仓位大小: "Ukuran posisi setelah transaksi",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Hasil perhitungan hanya untuk referensi, hasil sebenarnya dapat bervariasi karena perbedaan tarif",
  目标价格: "Target harga",
  开始计算: "Mulai menghitung",
  强平价格: "Harga likuidasi",
  " 充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平不会代理币的发放。":
    " Sebelum mengisi ulang, harap periksa dengan cermat nama rantai isi ulang. Jika isi ulang salah, aset tidak dapat diambil. {0}Jumlah isi ulang minimum adalah {1}; jika jumlahnya kurang dari jumlah ini, platform tidak akan dapat mengonfirmasi tanda terima. Harap jangan mengisi ulang aset selain {2} ke alamat ini, jika tidak maka tidak akan mungkin. Untuk mengambil aset, harap jangan menarik alamat crowdfunding atau ICO secara langsung, platform tidakakan bertindak sebagai proxy untuk penerbitan token.",
  "最小输入*": "Masukan minimal{0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    " Jumlah penarikan minimum adalah {0}, dan biaya penarikan akan dipotong dari jumlah penarikan Anda. Sebelum menarik koin, harap konfirmasi dan periksa alamat penerima, dan jangan menarik {1}ke alamat selain {2}, jika tidak, aset tidak akan dipulihkan. Tolong jangan menarik alamat crowdfunding atau ICOsecara langsung, platform tidak akan menangani penerbitan token.",
  退出登录: "Keluar",
  加仓: "Meningkatkan posisi",
  新增仓位: "Tambahkan posisi",
  输入加仓金额: "Masukkan jumlah kenaikan",
  "当前可用:": "Tersedia saat ini:",
  资产账单: "Tagihan Aset",
  保存二维码: "Simpan kode QR",
  温馨提示: "Tip yang baik",
  "请注意：您当前使用的网络": "Catatan: Jaringan Anda saat ini",
  输入提现地址: "Masukkan alamat penarikan",
  "可用金额：": "Jumlah yang Tersedia:",
  输入资产密码: "Masukkan kata sandi aset",
  可用手续费: "Biaya penanganan yang tersedia",
  "折扣%": "Diskon%",
  实扣手续费: "Biaya pemotongan sebenarnya",
  实际到账: "Kredit sebenarnya",
  未设置资产密码: "Kata sandi aset tidak disetel",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Demi keamanan aset Anda, harap setel kata sandi aset sebelum melakukan penarikan.",
  热榜: "Panas",
  涨幅榜: "Pemenang",
  跌幅榜: "Pecundang",
  成交额榜: "Omset",
  关于我们: "Tentang kami",
  登录密码: "Kata sandi masuk",
  设置: "Mempersiapkan",
  资产密码: "Kripto Aset",
  修改登录密码: "Ubah kata sandi masuk",
  原密码: "Password lama",
  请输入新密码: "Silakan masukkan kata sandi baru",
  请输入原密码: "Silakan masukkan kata sandi asli",
  确认密码: "Konfirmasi sandi",
  确定修改: "Oke untuk dimodifikasi",
  修改资产密码: "Ubah kata sandi aset",
  验证码: "Kode verifikasi",
  资产密码使用提示: "Kiat untuk menggunakan kata sandi aset",
  "资产密码用于转移、提取资产和交易。":
    "Aset Crypto digunakan untuk mentransfer, menarik aset, dan berdagang.",
  "创建与登录密码不同的资产密码。":
    "Buat kata sandi aset yang berbeda dari kata sandi login.",
  "定期更改您的资产密码。": "Ubah kata sandi aset Anda secara teratur.",
  提币历史: "Sejarah penarikan",
  "金额/余额": "Jumlah/Saldo",
  "手续费/折扣": "Biaya penanganan/diskon",
  自选: "Opsional",
  现货: "Barang spot",
  市价: "Harga pasar",
  止损设置: "Pengaturan stop loss",
  合约K线图: "Grafik kontrak K-line",
  "24H量": "Volume 24 jam",
  "24H额": "Jumlah 24 jam",
  合作指南: "Panduan Kerjasama",
  盈亏计算: "Perhitungan untung dan rugi",
  当前可用: "tersedia saat ini",
  请输入加仓金额: "Silakan masukkan jumlah kenaikan",
  请重新输入加仓金额: "Silakan masukkan kembali jumlah kenaikan",
  平仓数量: "Jumlah posisi yang ditutup",
  欢迎登录: "Silahkan masuk",
  "忘记密码?": "Tidak ingat kata sandi?",
  "还没有账号？": "Belum punya akun?",
  立即注册: "Daftar sekarang",
  繁體中文: "Cina tradisional",
  找回密码: "Ambil kata sandi",
  下一步: "Langkah berikutnya",
  注册账户: "Daftar akun",
  "请输入邀请码(选填)": "Silakan masukkan kode undangan (opsional)",
  谢邀豪礼: "Terima kasih atas undangannya",
  "24小时邀请好友排名": "24 jam undang peringkat teman",
  "*人": "{0}rakyat",
  "差*人": "{0}Orang miskin",
  "已超过10万人，每月轻松赚钱":
    "Memiliki lebih dari 100.000 orang, menghasilkan uang dengan mudah setiap bulan",
  最高: "Paling tinggi",
  邀请链接: "Tautan undangan",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Platform dan Anda berbagi biaya yang dihasilkan oleh teman Anda di platform (spot, kontrak, leverage, pertukaran flash)",
  平台和您一起分享手续费: "Platform berbagi biaya penanganan dengan Anda",
  "*级": "{0}kelas",
  规则: "Aturan",
  我的好友: "Teman baikku",
  好友详情: "Rincian teman",
  获得好友佣金方案: "Dapatkan Program Komisi Teman",
  我的等级: "Tingkat saya",
  我的邀请数据: "Data undangan saya",
  当前等级: "Level saat ini",
  平台奖励您: "Platform memberi Anda penghargaan",
  最高可获取平台奖励: "Imbalan platform tertinggi dapat diperoleh",
  邀请规则: "Aturan Undangan",
  "邀请*级有效好友": "Undang kelas {0} teman yang valid",
  好友等级: "Tingkat teman",
  人: "Rakyat",
  奖金派送: "Pengiriman bonus",
  平台奖励: "Hadiah platform",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    " Hak interpretasi terakhir adalah milik platform. Jika ditemukan bahwa hadiah platform diperoleh secara tidak normal, semua hadiah akan dipotong, danakun akan dibekukan, dan kehilangan aset tidak akan dipulihkan.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    " Akun Anda harus akun yang valid, dan platform menentukan bahwa kondisi akun yang valid adalah (akun diisi ulang dalam mata uang apa pun) nilai minimum{0} USDT.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    " Teman yang Anda undang harus bawahan yang valid. Platform menentukan bahwa bawahan yang valid adalah (isi ulang akun dalam mata uang apa pun) minimum {0}nilai USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Akun pengundang dan yang diundang tidak boleh memiliki IP yang sama.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "Tingkat VIP dinilai berdasarkan jumlah teman tingkat atas yang Anda undang.",
  佣金成分: "Komponen komisi",
  收益统计: "Statistik Pendapatan",
  昨日收益: "Penghasilan kemarin",
  月收益: "Pendapatan bulanan",
  获取收益: "Dapatkan manfaat",
  "总收益：": "Total pendapatan:",
  "*级好友": "{0}teman tingkat",
  理财购买: "Pembelian finansial",
  期限: "Syarat",
  可用金额: "Jumlah yang Tersedia",
  预估收益: "Perkiraan pendapatan",
  申购上限: "Batas berlangganan",
  项目剩余: "Proyek tersisa",
  "买入后预计*(SGT)开始计算收益。":
    "Diharapkan{0}(SGT) mulai menghitung penghasilan setelah membeli.",
  计息日: "Tanggal bunga",
  申购日: "Tanggal berlangganan",
  到账日: "Tanggal kedatangan",
  到期自动续投: "Perpanjangan otomatis setelah kedaluwarsa",
  申购: "Berlangganan",
  搜索理财项目: "Cari program keuangan",
  超高年化随心选: "Pilihan tahunan yang sangat tinggi",
  "自由选择理财币种，稳定超额收益":
    "Pilihan bebas mata uang manajemen kekayaan untuk menstabilkan pengembalian berlebih",
  理财总资产: "Total aset manajemen kekayaan",
  累计收益: "Pendapatan kumulatif",
  申购数量: "Jumlah pembelian",
  立即购买: "Beli sekarang",
  年化收益率: "Tingkat pengembalian tahunan",
  理财订单: "Urutan keuangan",
  持有: "Memegang",
  申购份额: "Berbagi langganan",
  到账日期: "Tanggal kedatangan",
  申购成功: "Berlangganan berhasil",
  到期: "Kematangan",
  是否选择做多: "Apakah Anda memilih untuk berbuat lebih banyak?",
  "可用余额为0 不能操作":
    "Saldo yang tersedia adalah 0 dan tidak dapat dioperasikan",
  福利中心: "Pusat Kesejahteraan",
  奖励记录: "Catatan hadiah",
  我获取到的奖励: "Imbalan yang saya dapatkan",
  总价值: "Nilai total",
  新手任务: "Tugas pemula",
  身份认证: "Autentikasi",
  身份验证: "Autentikasi",
  去验证: "Untuk memverifikasi",
  审核中: "Sedang ditinjau",
  已验证: "Diverifikasi",
  认证失败: "Otentikasi gagal",
  基础认证: "Sertifikasi Dasar",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Harap dicatat bahwa informasi otentikasi tidak dapat diubah setelah diverifikasi, pastikan untuk mengisi informasi yang benar",
  "国家/地区": "Negara / wilayah",
  请选择: "Tolong pilih",
  证件类型: "Jenis sertifikat",
  证件编码: "Kode dokumen",
  身份证: "KTP",
  护照: "Paspor",
  驾驶证: "SIM",
  请输入编码: "Silakan masukkan kode",
  名字: "Nama",
  请输入: "Silahkan masuk",
  中间名: "Nama tengah",
  选填: "Opsional",
  姓氏: "Nama keluarga",
  中国: "Cina",
  身份上传: "Unggah identitas",
  上传身份证: "Unggah identitas",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    " Materi di atas perlu diunggah dalam format JPG/JPEG/PNG, dan pastikan tepi dan sudut foto yang jelas sudah lengkap dan kecerahannya seragam. Danukurannya tidak melebihi {0}M.",
  确定提交: "Konfirmasi Pengajuan",
  去认证: "De-otentikasi",
  挑战任务: "Misi tantangan",
  注册认证任务: "Daftar untuk tugas sertifikasi",
  完成注册认证即可领取:
    "Setelah menyelesaikan sertifikasi pendaftaran, Anda dapat menerimanya",
  领取奖励: "Terima penghargaan",
  新人豪礼: "Hadiah pendatang baru",
  "参与人数：": "Jumlah peserta:",
  条件: "Kondisi",
  入金量: "Jumlah setoran",
  完成: "Menyelesaikan",
  任务奖励: "Hadiah misi",
  距任务更新: "Perbarui dari tugas",
  "条件：": "Kondisi:",
  活动规则: "Aturan kegiatan",
  奖励明细: "Detail Hadiah",
  已获得: "Diperoleh",
  交易奖励: "Imbalan transaksi",
  Win奖励: "Menangkan Hadiah",
  已领取: "Diterima",
  亏损金额超过: "Jumlah kerugian melebihi",
  单笔开仓金额超过: "Jumlah satu posisi terbuka melebihi",
  交易量: "Volume perdagangan",
  待完成: "Untuk diselesaikan",
  入金: "Menyetorkan",
  盈利金额超过: "Jumlah keuntungan melebihi",
  开仓金额: "Jumlah untuk membuka posisi",
  开仓金: "Posisi terbuka",
  盈利: "Laba",
  亏损: "Kehilangan",
  领取: "Menerima",
  未领取: "Tidak terbiasa",
  待领取: "Tertunda",
  再交易: "Perdagangan ulang",
  即可获得: "mendapatkan",
  领取成功: "Diterima dengan sukses",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Semua aktivitas akan dihitung sesuai dengan waktu terakhir aktivitas, dan pendapatan akan menjadi tidak valid setelah habis masa berlakunya.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Pendapatan yang diperoleh akan didistribusikan ke akun bounty Anda, dan Anda dapat menukar dan menariknya kapan saja sesuai dengan kebutuhan Anda.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Jenis mata uang hadiah yang diperoleh akan dikeluarkan sesuai dengan jenis tugas.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    " 4. Hak interpretasi akhir milik platform. Jika ditemukan bahwa ada cara abnormal untuk arbitrase bonus tugas platform, platform berhak untuk membekukandan menghapus pendapatan yang telah Anda peroleh.",
  成长学院: "Akademi Pertumbuhan",
  区块链: "blockchain",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Panduan satu atap Anda untuk cryptocurrency, kami membawa Anda ke jalan menuju cryptocurrency.",
  "全仓合约定单的全部保证金。": "Margin penuh untuk pesanan kontrak silang.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(saldo akun + (laba dan rugi mengambang - biaya penanganan - biaya semalam) = ekuitas / margin yang digunakan * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    ' Keuntungan dan kerugian mengambang akan secara langsung mempengaruhi "margin yang tersedia". Ketika laba dan rugi yang belum direalisasi meningkat,margin yang tersedia akan meningkat, dan laba rugi yang belum direalisasi akan berkurang, dan margin yang tersedia juga akan berkurang.',
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo akun - (margin yang digunakan) + (laba dan rugi mengambang - biaya penanganan - biaya semalam)",
  "注:可继续用于开仓的保证金。":
    "Catatan: Margin yang dapat terus digunakan untuk membuka posisi.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo akun + (laba dan rugi mengambang - biaya penanganan - biaya semalam)",
  "注:当前的资金结余。": "Catatan: Saldo dana saat ini.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Mengacu pada seluruh saldo akun kontrak, termasuk saldo yang tidak tersedia.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Catatan: Semakin tinggi tingkat risiko, semakin rendah risiko, dan semakin rendah tingkat risiko, semakin tinggi risikonya.",
  该功能尚未开发: "Fitur ini belum dikembangkan",
  重置密码: "setel ulang Kata Sandi",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Harap masukkan 8-20 karakter, harus mengandung huruf, angka, dan karakter khusus",
  修改成功: "Berhasil dimodifikasi",
  输入验证码: "Isilah dengan kode konfirmasi",
  输入密码: "Masukkan kata kunci",
  详情说明: "Rincian",
  已售罄: "Terjual habis",
  剩余期限: "Sisa periode",
  限期: "Tenggat waktu",
  闪兑货币选择: "Pilihan mata uang flash",
  地区选择: "Pemilihan wilayah",
  "搜索国家/地区": "Cari negara",
  "身份信息已提交，将在*小时内审核完成":
    "Informasi identitas telah dikirimkan dan akan ditinjau dalam {0} jam",
  "选择国家/地区": "Pilih negara",
  "止盈价格需高于*": "Harga Take Profit harus lebih tinggi dari {0}",
  "止损价格需低于*": "Harga stop loss harus lebih rendah dari {0}",
  "止盈价格需低于*": "Harga Take Profit harus lebih rendah dari {0}",
  "止损价格需高于*": "Harga stop loss harus lebih tinggi dari {0}",
  教程详情: "Detail Tutorial",
  请输入止损价: "Silakan masukkan harga stop loss",
  活期: "Saat ini",
  赎回后立即到账: "Segera setelah penukaran",
  赎回: "Penebusan",
  赎回理财: "Manajemen kekayaan penebusan",
  是否赎回当前的理财订单:
    "Apakah akan menebus pesanan manajemen kekayaan saat ini",
  维护: "Menjaga",
  "系统正在维护中……": "Sistem sedang dalam perbaikan...",
  合约: "Kontrak",
  闪电兑换: "Pertukaran Petir",
  流水挖矿: "Penambangan air mengalir",
  邀请豪礼: "Undangan Hao Li",
  计算器: "Kalkulator",
  最新价: "Harga terbaru",
  涨跌幅: "Perubahan kutipan",
  关注币种添加自选: "Ikuti mata uang untuk menambahkan opsional",
  一键添加自选: "Tambahkan satu klik opsional",
  全标已读: "Tanda penuh telah dibaca",
  无消息: "Tidak ada berita",
  "暂时还没有收到任何消息通知哦!": "Belum menerima pemberitahuan apa pun!",
  没有更多数据: "Tidak ada data lagi",
  闪兑: "Pertukaran kilat",
  从: "Dari",
  "可用余额：": "Saldo Tersedia:",
  至: "Ke",
  预览兑换结果: "Pratinjau hasil penukaran",
  闪兑规则: "Aturan pertukaran kilat",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Pertukaran flash pasar dapat berubah, silakan lihat jumlah sebenarnya yang diterima.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    " Nilai tukar ditetapkan oleh pihak ketiga. Karena biaya pertukaran dan fluktuasi pasar, nilai tukar yang Anda tukarkan mungkin lebih tinggi dari nilaitukar pasar. Harap konfirmasi dengan cermat sebelum melanjutkan.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Platform membebankan biaya penanganan sekitar {fee}% untuk setiap pertukaran, yang digunakan untuk membayar biaya pertukaran di bursa.",
  确认汇兑: "Konfirmasi pertukaran",
  您预估得到: "Anda memperkirakan",
  汇兑: "Menukarkan",
  汇兑比例: "Rasio pertukaran",
  刷新: "Menyegarkan",
  兑换: "Menukarkan",
  没有更多了: "Tidak lagi",
  搜索币种: "Cari mata uang",
  可用: "Tersedia",
  我知道了: "Saya mengerti",
  最新价格: "Harga terbaru",
  确认: "Konfirmasi",
  最大: "Maksimum",
  "风险率(%)": "Tingkat risiko (%)",
  持仓: "Posisi",
  当前委托: "Mandat saat ini",
  合作交易历史记录: "Riwayat transaksi kerjasama",
  重置: "Mengatur ulang",
  余额: "keseimbangan",
  现货账户: "Akun Pendanaan",
  合约账户: "Akun kontrak",
  WIN账户: "MENANGKAN akun",
  赏金账户: "Akun hadiah",
  总资产折合: "Total aset setara",
  今日收益: "Penghasilan hari ini",
  充币: "Menyetorkan",
  提币: "Menarik",
  账户权益: "Ekuitas Akun",
  "数量/类别": "Kuantitas/kategori",
  全部币种: "Semua mata uang",
  全部类型: "Semua jenis",
  账单信息: "Informasi tagihan",
  理财赎回: "Penebusan keuangan",
  购买理财: "Beli manajemen kekayaan",
  收入: "Penghasilan",
  支出: "Pengeluaran",
  到: "Tiba",
  资产划转: "Transfer aset",
  "最少*": "Paling sedikit*",
  "可用资产：": "Aset yang tersedia:",
  确认划转: "Konfirmasi transfer",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    " Transaksi hanya dapat dilakukan dengan mentransfer aset ke rekening terkait, dan tidak ada biaya penanganan yang akan dikenakan untuk transfer antarrekening.",
  币种账户选择: "Pilihan akun mata uang",
  选择账户: "Pilih akun",
  划转详情: "Rincian transfer",
  划转明细: "Rincian transfer",
  收入账单: "Tagihan pendapatan",
  支出账单: "Tagihan pengeluaran",
  金额: "Jumlah",
  总收益: "Total pendapatan",
  佣金: "Komisi",
  用户名: "Nama belakang",
  "已领取：": "Diterima:",
  "未领取：": "Belum terbiasa:",
  "请选择国家/地区": "Silakan pilih negara",
  请上传身份信息: "Harap unggah informasi identitas",
  请选择证件类型: "Silakan pilih jenis dokumen",
  请填写证件编码: "Silakan isi nomor ID",
  请填写名字: "Silahkan isi nama",
  请填写姓氏: "Silakan masukkan nama belakang",
  单向持仓: "Posisi satu arah",
  投资金额: "Jumlah investasi",
  天: "Langit",
  请输入手机号: "Silakan masukkan nomor telepon",
  搜索: "Cari",
  搜索历史: "Sejarah pencarian",
  热门推荐: "Rekomendasi populer",
  "《Xspace Earn协议》": '"Perjanjian Penghasilan Xspace"',
  我已了解并同意: "Saya mengerti dan setuju",
  协议: "Protokol",
  Xspace官方中文交流群: "Grup pertukaran Tiongkok resmi Xspace",
  Xspace官方英文交流群: "Grup pertukaran bahasa Inggris resmi Xspace",
  预计维护至: "Pemeliharaan diharapkan",
  更多功能: "Lebih banyak fitur",
  下载APP: "Unduh APLIKASI",
  理财: "Manajemen keuangan",
  推荐: "Menyarankan",
  Telegram官方中文频道: "Saluran resmi Cina Telegram",
  Telegram官方英文频道: "Saluran bahasa Inggris resmi Telegram",
  官方邮箱: "Kotak surat resmi",
  客服邮箱: "Email Layanan Pelanggan",
  上述信息最终解释权归官方所有:
    "Hak interpretasi akhir dari informasi di atas adalah milik pejabat",
  IOS版下载: "Unduh versi iOS",
  Android版下载: "Unduh untuk Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Biaya penanganan = biaya penanganan pembelian + tingkat pendanaan + biaya penanganan penjualan",
  资金划转: "Transfer dana",
  止盈: "Mengambil keuntungan",
  止损: "Hentikan kerugian",
  自动平仓: "Penutupan otomatis",
  委托挂单: "Pesanan tertunda yang dipercayakan",
  买: "Pembelian",
  卖: "Menjual",
  "买入/做多": "Beli/panjang",
  "卖出/做空": "Jual/singkat",
  详情: "Rincian",
  浮动涨跌: "mengambang ke atas dan ke bawah",
  最小: "Minimum",
  充币数量: "Jumlah setoran",
  请输入充币数量: "Silakan masukkan jumlah deposit",
  支付截图: "Tangkapan layar pembayaran",
  提交: "Kirimkan",
  上传驾驶证: "Unggah SIM",
  上传护照: "Unggah paspor",
  加载中: "Memuat",
  上传成功: "Berhasil diunggah",
  充值历史: "Isi ulang riwayat",
  合约卖出手续费: "Biaya penjualan kontrak",
  合约买入手续费: "Biaya pembelian kontrak",
  系统加款: "Tambahan sistem",
  系统减款: "Pengurangan sistem",
  合约资金费率: "Tingkat Pendanaan Kontrak",
  佣金分成: "Bagian komisi",
  U本位合约: "Kontrak standar U",
  资产管理: "Manajemen aset",
  APP下载: "Unduhan APLIKASI",
  全球领先的数字理财平台:
    "Platform manajemen kekayaan digital terkemuka di dunia",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Perdagangkan ratusan aset digital seperti Bitcoin dan Ethereum",
  "24H涨跌幅": "Perubahan 24 jam",
  查看更多行情: "Lihat lebih banyak kutipan",
  近24小时成交量: "Volume dalam 24 jam terakhir",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    " Menyediakan ratusan mata uang dan pasangan perdagangan kontrak untuk memenuhi kebutuhan perdagangan yang beragam. Platform ini memiliki lebih dari 20juta pengguna di 200 negara dan wilayah, dan merupakan platform layanan aset digital terkemuka di dunia.",
  用户国家分布: "Distribusi negara pengguna",
  用户数: "Nomor pengguna",
  交易对: "Pasangan perdagangan",
  服务支持: "Dukungan layanan",
  "随时随地，多平台终端交易":
    "Kapan saja, di mana saja, transaksi terminal multi-platform",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Multi-terminal sangat kompatibel dan dapat memenuhi kebutuhan transaksi berbagai skenario kapan saja.",
  随时查看实时行情: "Lihat kutipan real-time kapan saja",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Beli dan jual BTC, ETH, DOGE, dan aset digital lainnya dengan mudah",
  获取您关注的加密货币价格变化预警:
    "Dapatkan pemberitahuan tentang perubahan harga mata uang kripto yang Anda pedulikan",
  "查看比特币现货、期货、期权价格": "Lihat spot Bitcoin, futures, harga opsi",
  比较各交易所加密货币价格: "Bandingkan harga cryptocurrency di seluruh bursa",
  开启您的数字货币之旅: "Mulai perjalanan mata uang digital Anda",
  快捷购买数字货币: "Beli mata uang digital dengan cepat",
  "使用多种支付方式交易数字货币，安全快捷":
    "Gunakan berbagai metode pembayaran untuk berdagang mata uang digital, aman dan cepat",
  最优的交易费率: "tingkat transaksi terbaik",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Tarif transaksi preferensial, hak VIP kompetitif, nikmati layanan kualitas terbaik",
  可信赖的安全保障: "Keamanan yang andal",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Langkah-langkah keamanan canggih dan dana SAFU kami melindungi aset digital Anda dari semua risiko.",
  交易: "Berdagang",
  币币市场: "Pasar mata uang",
  "24H成交量": "Volume 24 jam",
  交易所: "Menukarkan",
  "24H最高": "Maksimum 24 jam",
  "24H最低": "Minimal 24 jam",
  永续合约: "Kontrak abadi",
  日涨跌: "Naik turun setiap hari",
  交易深度: "Kedalaman transaksi",
  "资产(合约)": "Aset (Kontrak)",
  历史仓位: "Posisi historis",
  兑换记录: "Pertukaran catatan",
  类型: "Tipe",
  充值记录: "Isi ulang catatan",
  划转记录: "Catatan transfer",
  类别: "Kategori",
  历史账单: "Tagihan bersejarah",
  在线充值: "Isi ulang online",
  安全设置: "Pengaturan keamanan",
  用于账户登录使用: "Untuk penggunaan login akun",
  用户提现时安全验证使用:
    "Verifikasi keamanan dan gunakan saat pengguna menarik uang tunai",
  验证: "Memeriksa",
  万: "Sepuluh ribu",
  随时随地开启交易: "Buka transaksi kapan saja, di mana saja",
  "*货币交易所的所有功能尽在你的手中。":
    "{0}Semua fungsi penukaran mata uang ada di tangan Anda.",
  "下载*货币交易所APP。": "Unduh {0} APLIKASI Penukaran Mata Uang.",
  下载自: "Unduh dari",
  内测版: "Beta tertutup",
  下载: "Unduh",
  扫码下载: "Pindai kode untuk mengunduh",
  设置您的资产密码: "Siapkan kata sandi aset Anda",
  法币: "Mata uang fiat",
  我要买: "Saya ingin membeli",
  我要卖: "Saya ingin menjual",
  请输入金额: "Silakan masukkan jumlahnya",
  汇率: "Kurs",
  获得: "Dapatkan",
  支付通道: "Saluran pembayaran",
  收款通道: "Saluran koleksi",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Selama proses penjualan, Anda perlu mengonfirmasi bahwa metode pembayaran Anda adalah milik Anda.",
  当前法币暂不支持交易对可尝试前往提现:
    "Mata uang legal saat ini tidak mendukung pasangan perdagangan, Anda dapat mencoba untuk menarik",
  前往提现: "Pergi ke uang tunai",
  该法币暂无通道: "Saat ini tidak ada saluran untuk mata uang fiat ini",
  "正在出售中，请耐心等待": "Dijual, harap bersabar",
  请选择支付通道: "Silakan pilih saluran pembayaran",
  请选择方式: "Silakan pilih metode",
  法币历史: "Sejarah Fiat",
  买币: "Membeli koin",
  卖币: "Menjual koin",
  失败: "Gagal",
  已完成: "Lengkap",
  未付款: "Belum dibayar",
  待审核: "Tinjauan tertunda",
  打款中: "Pembayaran",
  订单详情: "Detail pesanan",
  联系客服: "Hubungi Layanan Pelanggan",
  到账金额: "Jumlah yang diterima",
  通道: "Lorong",
  收款人: "Penerima pembayaran",
  收款账户: "Piutang",
  "订单出售失败，请查下方失败原因":
    "Pesanan gagal terjual, harap periksa alasan kegagalan di bawah ini",
  失败原因: "Alasan kegagalan",
  您还未进行付款: "Anda belum melakukan pembayaran",
  您已成功购买: "Anda telah berhasil membeli",
  已取消订单: "Pesanan dibatalkan",
  "订单正在审核中，请耐心等待":
    "Pesanan sedang dalam peninjauan, harap bersabar",
  您已成功出售: "Anda telah berhasil menjual",
  "订单正在打款中，请耐心等待": "Pesanan sedang dibayar, harap bersabar",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Proses pembayaran mengharuskan Anda untuk pergi ke platform lain untuk membayar pesanan, harap perhatikan keamanan informasi.",
  当前法币暂不支持交易对可尝试前往充值:
    "Mata uang fiat saat ini tidak mendukung pasangan perdagangan, Anda dapat mencoba mengisi ulang",
  前往充值: "Pergi untuk mengisi ulang",
  购买: "Membeli",
  订单号: "Jumlah order",
  单价: "Patokan harga",
  到账数量: "Jumlah ke akun",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Saat ini ada pesanan yang belum dibayar, apakah Anda ingin melanjutkan untuk memulai pesanan pembayaran baru?",
  继续支付: "Terus bayar",
  重新下单: "Pesan ulang",
  是否确定出售: "Apakah Anda yakin untuk menjual?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Setelah penjualan dikonfirmasi, platform akan dialokasikan ke pembeli, harap tunggu dengan sabar hingga platform cocok.",
  出售: "Menjual",
  收款方式: "Cara Pembayaran",
  订单已生成: "Pesanan telah dibuat",
  取消订单: "Batalkan pesanan",
  请在: "Tolong di",
  内完成付款: "Selesaikan pembayaran dalam",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注":
    "Tinggalkan platform, masuk ke pembayaran yang Anda tentukan, transfer uang ke akun penjual di bawah, dan pastikan untuk membuat catatan dalam pembayaran",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    " Jika tidak ada komentar yang dibuat pada saat pembayaran, penjual tidak akan dapat mengkonfirmasi pembayaran, yang mengakibatkan hilangnya aset yangtidak dapat dipulihkan.",
  "未在规定的时间内付款，订单都将被取消。":
    "Jika pembayaran tidak dilakukan dalam waktu yang ditentukan, pesanan akan dibatalkan.",
  姓名: "Nama",
  收款姓名: "Nama penerima pembayaran",
  开户支行: "Cabang pembukaan rekening",
  银行卡号: "Nomor kartu bank",
  "付款后，返回本平台": "Setelah pembayaran, kembali ke platform ini",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    'Pastikan untuk mengklik tombol "Saya telah menyelesaikan pembayaran, beri tahu penjual" di bawah ini',
  未点击卖家不会放款:
    "Jika Anda tidak mengklik, penjual tidak akan melepaskan uangnya",
  交易条款: "Syarat transaksi",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Membeli sumber dana, Anda harus memiliki dana yang legal dan aman sebelum Anda dapat berdagang",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Penipuan, skema piramida, perjudian, atau transaksi keuangan ilegal lainnya tidak diperbolehkan",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    " Setelah transaksi selesai, ada risiko dana, beku atau dicurigai penipuan, skema piramida, dana perjudian, kami tidak akan melepaskan U kepada pembeli,dan memberikan pengembalian dana",
  "已付款，通知卖家": "Dibayar, beri tahu penjual",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Jika pembeli membatalkan {0} pesanan pada hari yang sama, fungsi pembelian di hari yang sama akan dibatalkan. Anda yakin ingin membatalkan pesanan ini?",
  添加收款方式: "Tambahkan metode pembayaran",
  是否删除此收款方式: "Apakah akan menghapus metode pembayaran ini",
  删除: "Menghapus",
  请选择法币: "Silakan pilih mata uang fiat",
  机构名称: "Nama Lembaga",
  请选择机构: "Silakan pilih institusi",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    " Saat Anda menjual mata uang digital, metode pembayaran yang Anda pilih akan ditampilkan kepada pembeli, harap konfirmasikan bahwa itu diisi denganbenar.",
  请选择银行: "Silakan pilih bank",
  请输入姓名: "Silakan ketik nama Anda",
  账号: "Akun",
  请输入账号: "Silahkan masuk akun",
  收款码: "Kode tanda terima",
  "银行账号/卡号": "Nomor rekening/kartu bank",
  "请输入银行账号/卡号": "Masukkan nomor rekening/kartu bank",
  "开户支行（选填）": "Cabang pembukaan rekening (opsional)",
  请输入开户支行: "Silakan masukkan cabang pembukaan rekening",
  "加入*官方频道": "Bergabunglah dengan {0}Saluran Resmi",
  关于: "Tentang",
  条款: "Ketentuan",
  其他: "Lainnya",
  成功: "Kesuksesan",
  等待: "Tunggu",
  作废: "Ruang kosong",
  确认付款: "Konfirmasi pembayaran",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Apakah pembayaran sudah dilakukan? Jika pembayaran sudah dikonfirmasi, merchant akan mengkonfirmasi apakah pembayaran sudah diterima dalam {0} menit.",
  最大金额: "Jumlah maksimum",
  最小金额: "Jumlah minimal",
  付款: "Pembayaran",
  法币充值: "Isi ulang mata uang fiat",
  法币提现: "Penarikan Fiat",
  待支付: "Untuk dibayar",
  已支付: "Dibayar",
  商户名: "Nama pedagang",
  当前没有添加支付方式: "Saat ini tidak ada metode pembayaran yang ditambahkan",
  添加后再出售: "Tambahkan untuk dijual",
  新人大礼包: "Paket hadiah pendatang baru",
  注册即可领取: "Daftar untuk menerima",
  立即领取: "Dapatkan sekarang juga",
  不再提示: "Jangan ingatkan lagi",
  "该奖励需在APP中领取，请下载APP":
    "Hadiah perlu dikumpulkan di APP, silakan unduh APP",
  去交易: "Untuk berdagang",
  期权交易: "Perdagangan Opsi",
  交易额: "Jumlah transaksi",
  可用额度: "Kuota yang tersedia",
  交易周期: "Siklus perdagangan",
  看涨: "Optimis",
  看跌: "Kasar",
  当前持有: "Saat ini diadakan",
  胜率: "Tingkat kemenangan",
  "盈利/亏损数": "Rugi laba",
  累计实现盈亏: "Akumulasi keuntungan dan kerugian yang direalisasikan",
  秒: "Kedua",
  分: "Menit",
  小时: "Jam",
  天: "Langit",
  周: "Pekan",
  下单时间: "Waktu pemesanan",
  剩余时间: "Waktu tersisa",
  买入价: "Harga beli",
  结算价: "Harga Penyelesaian",
  实现盈利: "Memperoleh keuntungan",
  结算时间: "Waktu penyelesaian",
  期权: "Pilihan",
  新手教程: "Tutorial Pemula",
  我的订单: "Pesananku",
  赔率: "Kemungkinan",
  全部订单: "Semua perintah",
  持有订单: "Tahan pesanan",
  历史订单: "Riwayat pesanan",
  输入交易额度: "Masukkan jumlah transaksi",
  选择交易周期: "Pilih siklus perdagangan",
  去注册: "Mendaftar",
  冻结: "Membekukan",
  期权支出: "Pembayaran opsi",
  期权收入: "Pendapatan opsi",
  用户提现: "Penarikan pengguna",
  "是否购买？": "Apakah Anda ingin membeli?",
  购买成功: "Pembelian sukses",
  请签名: "Tolong tanda tangani",
  提交签名: "Menyerahkan tanda tangan",
  清空签名: "Tanda tangan yang jelas",
  签名审核中: "Ulasan tanda tangan",
  已提交: "Diserahkan",
  扫一扫下载APP: "Pindai untuk mengunduh APLIKASI",
  新手领取大礼包: "Pemula menerima kesenangan",
  注册实名即送彩金: "Daftar",
  交易总额: "Total transaksi",
  资产不足: "Aset tidak mencukupi",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "Aset di akun Win tidak mencukupi dan dapat ditransfer dari akun pendanaan ke akun ini",
  Win: "Menang",
  在线充值: "Isi ulang online",
  比赛: "Kontes",
  未开始: "Belum dimulai",
  赛程: "Jadwal",
  赛果: "Hasil",
  已结束: "Lebih",
  让球: "Rintangan",
  进球数: "Sasaran",
  大: "Besar",
  小: "Kecil",
  胜负平: "Menang atau kalah",
  和局: "Permainan yang ditarik",
  投注: "Bertaruh",
  下注金额: "Jumlah taruhan",
  下注: "Bertaruh",
  阵容: "Berbaris",
  分析: "Menganalisa",
  输入下注金额: "Masukkan jumlah taruhan",
  下注成功: "Taruhan sukses",
  投注记录: "Rekor taruhan",
  未结算: "Keresahan",
  已结算: "Mapan",
  流水: "Air mengalir",
  输赢: "Menang atau kalah",
  赛时: "Waktu bermain",
  下注时间: "Waktu taruhan",
  足彩竞猜: "Kuis sepak bola",
  查看详情: "Cek detailnya",
  输: "Kehilangan",
  赢: "Menang",
  主: "Tuan rumah",
  客: "Tamu",
  主胜: "Kemenangan utama",
  客胜: "Pelanggan menang",
  平: "Datar",
  已延期: "Ditunda",
  账号异常: "Pengecualian akun",
  全场独赢: "1x2",
  全场让球: "Handicap",
  全场大小: "Over/Under",
  总进球: "Total gol",
  拍摄照片要求: "Persyaratan foto",
  标准拍摄: "Tembakan standar",
  边框缺失: "Perbatasan hilang",
  照片模糊: "Foto buram",
  闪光强烈: "Flash yang kuat",
  上传手持证件照: "Unggah dokumen genggam",
  上传证件照: "Unggah foto identitas",
  换一张: "Ganti satu",
  出生日期: "Tanggal lahir",
  请选择出生日期: "Silakan pilih tanggal lahir",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Setelah memasukkan verifikasi grafis yang benar di bawah ini, dapatkan kode verifikasi email untuk pendaftaran",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Anda memiliki {0} sertifikasi yang tersisa, setelah itu Anda tidak dapat melanjutkan sertifikasi",
  上半场: "Babak pertama",
  下半场: "Babak kedua",
  独赢: "1x2",
  上半场独赢: "Babak pertama 1x2",
  下半场独赢: "Babak kedua 1x2",
  上半场让球: "Babak pertama Handicap",
  下半场让球: "Babak kedua Handicap",
  上半场大小球: "Babak pertama Over/Under",
  下半场大小球: "Babak kedua Over/Under",
  波胆: "Correct Score",
  上半场波胆: "Babak pertama Correct Score",
  下半场波胆: "Babak kedua Correct Score",
  单双: "Odd/Even",
  上半场单双: "Babak pertama Odd/Even",
  下半场单双: "Babak kedua Odd/Even",
  总进球: "Total Goal",
  上半场总进球: "Babak pertama Total Goal",
  下半场总进球: "Babak kedua Total Goal",
  单: "Odd",
  双: "Even",
  中场: "Lini tengah",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Catatan: Silakan ikuti contoh gambar ini untuk menulis teks di atas kertas putih dan mengambil foto dengan kartu ID",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Baru-baru ini, sejumlah besar akun curang telah ditemukan, dan sejumlah akun ilegal telah dihukum. Jika ada salah penilaian sebagai akun ilegal, silakan hubungi layanan pelanggan online.",
  最小下注金额: "Jumlah taruhan minimum",
  参与活动最小下注金额:
    "Jumlah taruhan minimum untuk berpartisipasi dalam acara",
  记住密码: "Ingat kata Sandi",
  比分: "Skor",
  "您还未登录，请先登录": "Silahkan masuk",
  立即登录: "Gabung",
  下注限额: "Batas taruhan",
  可赢金额: "Bisa menang",
  闪兑详情: "Detail Flash",
  大小球: "Over/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Karena nilai tukar, akan ada perbedaan antara jumlah taruhan dan jumlah taruhan yang sebenarnya, harap lihat pesanannya.",
  开赛时间: "Waktu mulai",
  足球收入: "Pendapatan sepakbola",
  足球支出: "Pembelanjaan sepak bola",
  活动详情: "Detail aktivitas",
  为世界杯喝彩: "Semangat untuk piala dunia",
  我的竞猜: "-ku",
  "竞猜比赛、有机会瓜分*USDT":
    "Tebak permainannya dan dapatkan kesempatan untuk membagikan {0}USDT",
  "瓜分*USDT": "Bagikan {0}USDT",
  距离活动结束还有: "Akhir jarak",
  我的门票: "Tiket saya",
  竞猜结束时间: "Tebak waktu berakhir",
  猜比分: "Tebak skornya",
  "福利派送中，完成任务即可获取门票":
    "Distribusi kesejahteraan sedang berlangsung, selesaikan tugas untuk mendapatkan tiket",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Selesaikan tugas berikut, Anda bisa mendapatkan jumlah tiket yang sesuai untuk berpartisipasi dalam kompetisi",
  时: "Jam",
  活动: "Aktivitas",
  竞猜记录: "Tebak rekor",
  结果: "Hasil",
  任务: "Tugas",
  去邀请: "Mengundang",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Skor setiap permainan ditebak, dan ${0} dapat dibagi menjadi hadiah untuk berpartisipasi dalam kontes.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Berpartisipasi dalam kuis membutuhkan tiket, yang dapat diperoleh sesuai dengan tugas platform.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "Setelah kompetisi berhasil, kirimkan screenshot hasil kompetisi ke layanan pelanggan, dan layanan pelanggan akan mengirimkan bonus ke akun dana Anda, dan Anda dapat segera menariknya.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Kecurangan apa pun dilarang, dan hadiah akan dibatalkan jika ditemukan kecurangan.",
  "完成任务后，点击咨询客服获得门票。":
    "Setelah menyelesaikan tugas, klik Konsultasikan Layanan Pelanggan untuk mendapatkan tiket.",
  继续猜: "Terus menebak",
  总单数: "Total tunggal",
  赛事筛选: "Pemutaran acara",
  球队筛选: "Pemilihan tim",
  总金额: "Jumlah bulat",
  总流水: "Omzet total",
  派奖金额: "Jumlah bonus",
  下注单数: "Nomor pesanan",
  利润: "Laba",
  更多福利: "Kesejahteraan",
  我的奖金: "Bonus saya",
  未认证: "Tidak bersertifikat",
  总量: "Total",
  或: "Atau",
  模拟交易: "Perdagangan demo",
  体验账户不可操作: "Akun pengalaman tidak dapat dioperasikan",
  世界杯比分竞猜: "Kuis skor Piala Dunia",
  "领*USDT起": "Dari {0}USDT",
  消息: "Informasi",
  滚球: "Bola berguling",
  是: "ya",
  不是: "Tidak",
  当前余额: "saldo saat ini",
  KOL招募: "perekrutan KOL",
  本月净输赢: "Menang/kalah bersih untuk bulan itu",
  本月佣金: "komisi bulan ini",
  佣金比例: "Tingkat komisi",
  活跃人数: "nomor aktif",
  新增下级: "Tambah bawahan",
  登录人数: "jumlah login",
  首存人数: "Jumlah deposan pertama",
  数据分析: "analisis data",
  人数: "jumlah orang",
  新注册存款金额: "Jumlah setoran baru yang terdaftar",
  老用户存款金额: "Jumlah setoran pengguna lama",
  首存金额: "Jumlah setoran pertama",
  快捷入口: "Entri cepat",
  成员管理: "manajemen anggota",
  财务报表: "Laporan keuangan",
  分红报表: "Laporan dividen",
  订单记录: "catatan pesanan",
  VIP专享: "Eksklusif VIP",
  推广工具: "alat promosi",
  计算规则: "Aturan Perhitungan",
  账变明细: "Detail perubahan akun",
  成员: "anggota",
  下级概览: "Gambaran bawahan",
  下级成员总计: "Jumlah Anggota Bawahan",
  本月新增: "baru bulan ini",
  本月活跃会员: "Anggota aktif bulan ini",
  今日活跃会员: "Anggota Aktif Hari Ini",
  本月有效活跃: "aktif bulan ini",
  活跃成员占比: "Proporsi Anggota Aktif",
  本月活跃: "aktif bulan ini",
  今日活跃: "aktif hari ini",
  下级成员: "anggota muda",
  会员账号: "akun anggota",
  统计时间: "Waktu Statistik",
  筛选: "Saring",
  存款: "menyetorkan",
  取款: "menarik uang",
  总输赢: "total menang atau kalah",
  是否有效用户: "Apakah itu pengguna yang valid",
  最近登录时间: "waktu masuk terakhir",
  否: "Tidak",
  开始时间: "Waktu mulai",
  结束时间: "Akhir waktu",
  提取: "ekstrak",
  总盈亏: "keuntungan dan kerugian secara keseluruhan",
  净盈亏: "laba bersih dan rugi",
  分红: "dividen",
  概览: "gambaran",
  月度详细数据: "Data bulanan terperinci",
  未发放: "tidak dikeluarkan",
  活跃用户: "pengguna aktif",
  有效新增会员: "Menambah anggota baru secara efektif",
  冲正后净输赢: "Menang atau kalah bersih setelah pembilasan",
  上月结余: "Saldo bulan lalu",
  净输赢: "menang/kalah bersih",
  "系统每日新加坡时间1:00更新一次报表":
    "Sistem memperbaharui laporan setiap hari pada jam 1:00 Singapura",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Angka positif dalam data, total kemenangan dan kekalahan, serta kemenangan dan kekalahan bersih dalam laporan menunjukkan keuntungan agen, dan angka negatif menunjukkan kerugian agen",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Data komisi diperbarui setiap hari dan hanya untuk referensi, bukan standar pembagian komisi yang sebenarnya",
  选择时间: "periode seleksi",
  足球: "sepak bola",
  投注金额: "jumlah taruhan",
  有效订单: "pesanan yang sah",
  下级账户: "Akun bawahan",
  待成交: "kesepakatan tertunda",
  下单金额: "jumlah pesanan",
  订单内容: "memesan konten",
  秒数: "detik",
  联赛: "liga",
  队伍: "tim",
  比赛时间: "Waktu bersaing",
  玩法: "Cara bermain",
  等级规则表: "Tabel Aturan Nilai",
  等级: "nilai",
  活跃会员: "anggota aktif",
  最新活跃: "aktif terbaru",
  额外佣金: "komisi ekstra",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Standar pertumbuhan dan sistem hadiah dari level yang sesuai diterapkan setiap bulan, dan hanya satu hadiah level yang dapat dinikmati.",
  渠道生成: "generasi saluran",
  创建: "membuat",
  渠道名称: "nama saluran",
  注册人数: "jumlah pendaftar",
  浏览人数: "Pemirsa",
  构建状态: "membangun status",
  禁用: "dengan disabilitas",
  启用: "memungkinkan",
  查看: "Memeriksa",
  创建渠道: "membuat saluran",
  创建成功: "berhasil dibuat",
  操作成功: "Operasi sukses",
  渠道详情: "Detail Saluran",
  邀请码: "Kode undangan",
  访问人数: "jumlah pengunjung",
  渠道地址: "alamat saluran",
  我的福利: "manfaat saya",
  充值福利: "Manfaat isi ulang",
  当前流水: "aliran arus",
  如何参与: "bagaimana berpartisipasi",
  币种充值: "Isi ulang mata uang",
  充值福利中领取福利: "Dapatkan keuntungan dari manfaat top-up",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Aturan: Manfaat isi ulang bersifat sukarela untuk diterima, dan masa berlaku dalam 24 jam setelah isi ulang. Ini akan menjadi tidak berlaku setelah tanggal kedaluwarsa. Setelah menerimanya, fungsi penarikan tunai akan dikunci sementara, dan penarikan tunai dapat dilakukan dibuka setelah omset tercapai.",
  失效日期: "tanggal habis tempo",
  "暂无福利领取，充值后领取":
    "Belum ada manfaat untuk diterima, terima setelah diisi ulang",
  参与: "ikut",
  充值赠送: "Isi ulang hadiah",
  "领取*%的赠送": "Menerima {0}% hadiah",
  去领取: "untuk mengumpulkan",
  VIP奖励: "Hadiah VIP",
  "当前可领取*USDT，是否确认领取":
    "Dapat menerima {0}USDT saat ini, apakah Anda mengonfirmasi klaim?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Setelah mengklaim, fungsi penarikan akan dikunci sementara, dan kunci dapat dibuka saat omset Anda mencapai {0}USDT",
  充值送大礼: "Top up untuk mendapatkan hadiah besar",
  "存入越多，送越多！":
    "Semakin banyak Anda menyetor, semakin banyak yang Anda dapatkan!",
  无效: "tidak sah",
  有效: "efisien",
  总存金额: "jumlah total setoran",
  提示: "petunjuk",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Angka positif dalam total kemenangan dan kekalahan serta kemenangan dan kekalahan bersih menunjukkan keuntungan platform, dan angka negatif menunjukkan kerugian Data harian hanya untuk referensi dan tidak berfungsi sebagai standar distribusi komisi yang sebenarnya.",
  "净盈亏：总盈亏-用户返水":
    "Laba dan rugi bersih: laba dan rugi total - rabat pengguna",
  盈利方: "Partai yang menguntungkan",
  代理: "akting",
  客户: "klien",
  平局: "menggambar",
  平台: "peron",
  "已提交审核，请耐心等待": "Dikirim untuk ditinjau, harap bersabar",
  充值日期: "tanggal isi ulang",
  平台本月总输赢: "Total kemenangan dan kekalahan platform bulan ini",
  KOL招募合作: "Kerjasama rekrutmen KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Platform sekarang buka [Acara Rekrutmen KOL], selama Anda memiliki akun media sosial, Anda dapat menikmati bonus satu kali dengan platform untuk mempromosikan pelanggan, dan Anda dapat menikmati manfaat seumur hidup.",
  级别: "tingkat",
  平台利润返佣: "Rabat laba platform",
  佣金案例: "Kasus komisi",
  交易项目: "barang transaksi",
  "期权交易、合约交易、足球游戏":
    "Perdagangan opsi, perdagangan kontrak, pertandingan sepak bola",
  报名方式: "cara pendaftaran",
  点击KOL招募报名: "Klik pendaftaran rekrutmen KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Selamat bergabung dengan tim kami, platform ini sepenuhnya mendukung Anda untuk membuat sistem pengguna Anda sendiri, dan Anda bisa mendapatkan komisi{0} tertinggi, kami menantikan Anda bergabung.",
  输入联系方式: "Masukkan informasi kontak",
  最低活跃人数: "Nomor Aktif Minimal",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Misalnya: jumlah pengguna aktif bulan ini ≥ {0} dan total menang atau kalah platform bulan ini ≥ {1}USDT, Anda termasuk level {2}, Anda bisa mendapatkan komisi {3}%.",
  比分竞猜: "Tes skor",
  豪礼相赠: "Hadiah",
  足球活动: "Aktivitas sepak bola",
  圣诞节活动: "Aktivitas Natal",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Anda telah berpartisipasi dalam aktivitas dan sementara mengunci fungsi penarikan. Anda perlu aliran USDT {0} untuk membukanya.",
  剩余流水: "Air sisa",
  助力足球: "Boost football",
  佣金累计: "Total komisi",
  有效投注: "Taruhan yang sah",
  今日: "Hari ini",
  今日返水: "Rabat hari ini",
  VIP返水: "Potongan harga VIP",
  返水记录: "Rekor rabat",
  成员信息: "Informasi anggota",
  基本信息: "Informasi dasar",
  钱包余额: "Saldo dompet",
  投注信息: "Informasi taruhan",
  返水: "Potongan harga",
  总下注: "Total taruhan",
  今日输赢: "Menang atau kalah hari ini",
  下注动态: "Dinamika Taruhan",
  返水奖励: "Bonus rabat",
  分红金额: "Jumlah dividen",
  返水支出: "Pembayaran rabat",
  总返水: "Rabat total",
  流水总额: "Total omset",
  返水总额: "Total Rabat",
  返水详情: "Detail Rebate",
  日流水: "Air harian",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Platform memberikan reward rebate tambahan berdasarkan turnover harian bawahan Anda, dan reward akan didistribusikan ke akun reward pada pukul 00:00 waktu Singapura setiap hari",
  "申请成功，等待审核": "Aplikasi berhasil, menunggu peninjauan",
  "我出本金，盈利共分享": "Saya membayar pokok dan berbagi keuntungan",
  最高分红: "dividen tertinggi",
  投资大师比赛: "Kompetisi Master Investasi",
  "我出本金，你盈利": "Saya membayar pokoknya, Anda untung",
  共分享: "bersama",
  最高分红可得: "Dividen maksimum tersedia",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Manfaat eksklusif untuk pengguna baru akan datang, ${0} gratis, Anda dapat berinvestasi dalam proyek apa pun di platform setelah menerimanya, dan Anda dapat menariknya segera setelah mendapat untung.",
  报名领取: "Daftar untuk menerima",
  已领取: "diterima",
  审核驳回: "Ulasan ditolak",
  驳回原因: "Alasan penolakan",
  活动运行周期: "Siklus menjalankan aktivitas",
  "申请成功后起至*天内完成超额收益。":
    "Setelah aplikasi berhasil, kelebihan penghasilan akan diselesaikan dalam waktu {0} hari.",
  分红比: "Rasio dividen",
  "*日获得盈利后，可获得*%的收益额。":
    "Setelah mendapatkan keuntungan pada hari {0}, Anda bisa mendapatkan {1}% dari keuntungan.",
  参与条件: "Kondisi partisipasi",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Pengguna di Rusia dan Turki tidak berpartisipasi.",
  计算项目: "butir perhitungan",
  "合约、体育、期权": "Kontrak, Olahraga, Opsi",
  我的投资: "investasi saya",
  参与天数: "Hari partisipasi",
  累计下注: "taruhan kumulatif",
  累计盈亏: "Akumulasi keuntungan dan kerugian",
  预计可分红: "Diharapkan untuk membayar dividen",
  常见问题: "masalah umum",
  什么是平台出资: "Apa itu pendanaan platform",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Menurut pengguna di beberapa negara, platform ini menyediakan dana gratis bagi pengguna untuk berinvestasi dalam proyek.",
  怎么获取平台出资的福利: "Cara mendapatkan manfaat dari kontribusi platform",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Anda hanya perlu menjadi pengguna di negara yang ditentukan, klik tombol pendaftaran di atas, dan {0}USDT akan ditransfer ke akun hadiah di bawah akun saat ini setelah peninjauan platform selesai, dan Anda dapat mentransfernya ke akun lain untuk investasi.",
  什么是分红: "apa itu dividen",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividen artinya dalam jangka waktu tertentu, setelah pendapatan mencapai 100%, 50% dari kelebihan pendapatan dapat dibagikan. Contoh: Untuk menerima dana 100USDT, jumlah pendapatan adalah 120%.",
  "如何取得分红？": "Bagaimana cara mendapatkan dividen?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Siklus aktivitas adalah sekali setiap {0}hari Setelah aktivitas selesai, akan dihitung, dan dividen akan didistribusikan ke akun bounty setelah memenuhi persyaratan aktivitas. Jika Anda tidak memenuhi persyaratan aktivitas, sistem akan secara otomatis menghapus pendapatan dan kontribusi platform Anda.",
  活动规则: "Aturan Kegiatan",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Akun yang berpartisipasi harus menjalani verifikasi KYC, dan setiap akun dibatasi untuk satu manfaat.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC dari akun yang berpartisipasi memerlukan negara yang ditentukan untuk berpartisipasi, dan wilayah lain tidak diizinkan untuk berpartisipasi. Harap periksa apakah negara yang aktif konsisten dengan negara Anda.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Setelah berhasil berpartisipasi dalam aktivitas, akun akan mengunci sementara fungsi penarikan Anda, dan fungsi penarikan Anda akan dilepaskan setelah aktivitas selesai.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Harap patuhi aturan aktivitas platform. Jika Anda menemukan kecurangan atau mengeksploitasi celah sistem untuk mendapatkan keuntungan, platform akan membekukan semua dana di akun Anda untuk waktu yang lama.",
  平台出资: "Investasi platform",
  平台出资收回: "Pemulihan investasi platform",
  投资大师奖励: "Penghargaan Master Investasi",
  请下载APP添加收款方式:
    "Silakan unduh aplikasi untuk menambahkan metode pembayaran",
  请下载APP进行身份验证: "Silakan unduh aplikasi untuk verifikasi identitas",
  请下载APP参与: "Silakan unduh aplikasi untuk berpartisipasi",
  技术指标: "Indikator teknis",
  主图: "Gambar utama",
  副图: "Sub-gambar",
  新注册人数: "Pendaftar baru",
  老用户存款人数: "Simpanan pengguna lama",
  存款人数: "Jumlah deposan",
  取款人数: "Jumlah penarikan",
  投注人数: "Jumlah petaruh",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Kecuali Indonesia, India, Bangladesh, dan pengguna yang belum berpartisipasi.",
  市场动态: "Dinamika pasar",
  外汇合约: "kontrak valuta asing",
  盈亏比: "rasio untung-rugi",
  委托价: "Harga pesanan",
  可用余额: "Saldo Tersedia",
  持仓额: "Jumlah posisi",
  强平价: "Paritas yang kuat",
  修改: "Merevisi",
  修改价位: "Ubah harga",
  外汇: "Valas",
  外汇账户: "akun valas",
  我的交易: "transaksi saya",
  未设置: "tidak diatur",
  超出最大可设数值: "Melebihi nilai maksimum yang dapat ditetapkan",
  超出最小可设数值: "Melebihi nilai minimum yang dapat ditetapkan",
  止盈超出最小可设数值:
    "Take profit melebihi nilai minimum yang dapat ditetapkan",
  止损超出最大可设数值:
    "Stop loss melebihi nilai maksimum yang dapat ditetapkan",
  止盈超出最大可设数值:
    "Take profit melebihi nilai maksimum yang dapat ditetapkan",
  止损超出最小可设数值:
    "Stop loss melebihi nilai minimum yang dapat ditetapkan",
  挖矿: "Pertambangan",
  交易账户: "akun transaksi",
  买涨: "Memborong",
  买跌: "Beli atau jual",
  请输入正确的银行卡信息: "Silakan masukkan informasi kartu bank yang benar",
  联系在线客服: "Hubungi layanan pelanggan online",
  法币交易请联系在线客服:
    "Untuk transaksi mata uang legal, silakan hubungi layanan pelanggan online",
  提交订单: "Masukan pesanan",
  "支付过程如有疑问,请联系在线客服":
    "Jika Anda memiliki pertanyaan tentang proses pembayaran, silakan hubungi layanan pelanggan online",
  彩金赠送: "Hadiah loteri",
  在线客服: "layanan daring",
  最少投资: "investasi minimum",
  "提交时间:": "Waktu penyerahan:",
  提现拒绝: "Penarikan ditolak",
  认证拒绝: "Otentikasi ditolak",
  认证通过: "Sertifikasi lulus",
  请输入正确的交易额度: "Silakan masukkan jumlah transaksi yang benar",
  最大下注金额: "Jumlah taruhan maksimum",
  手机号: "Nomor telepon",
  邮箱注册: "registrasi email",
  手机号注册: "Pendaftaran nomor ponsel",
  查询: "Menanyakan",
  手机号登录: "Login nomor ponsel",
  邮箱登录: "Masuk Email",
  请输入数量: "Silakan masukkan kuantitas",
  可用数量: "Kuantitas Tersedia",
  钱包登录: "Masuk dompet",
  请输入正确的邀请码: "Silakan masukkan kode undangan yang benar",
  "请输入邀请码(必填)": "Silakan masukkan kode undangan (wajib)",
  输入正确的金额: "Masukkan jumlah yang benar",
  法币充值: "isi ulang dengan mata uang nasional",
  卢比充值: "Isi Ulang Rupee",
  请输入法币: "Masukkan Mata Uang",
  请输入IFSC: "Masukkan IFSC",
  "银行编码(选填)": "Kode Bank (Opsional)",
  请输入银行编码: "Masukkan Kode Bank",
  请输入大于8位数的密码: "Silakan masukkan kata sandi lebih dari 8 digit",
  添加成功: "Berhasil ditambahkan",
  "60秒": "60 detik",
  "180秒": "180 detik",
  "300秒": "300 detik",
  "2次密码不一致": "2 kata sandi tidak konsisten",
  输入提币数量: "Masukkan jumlah penarikan",
  图片格式不正确: "Format gambar tidak benar",
  图片大于20M: "Ukuran gambar lebih dari 20M",
  请设置委托价格: "Silakan tetapkan harga komisi",
  输入资金密码: "Masukkan kata sandi dana",
  验证码错误: "Kesalahan kode verifikasi",
  充值拒绝: "Isi ulang ditolak",
  请输入SSN: "Silakan masukkan SSN",
  合约交易: "perdagangan kontrak",
  结算完成: "Penyelesaian selesai",
  继续下单: "Lanjutkan pemesanan",
  最低购买: "pembelian minimal",
  最高购买: "pembelian tertinggi",
  限价: "Harga Batas",
  买入价格: "Harga Beli",
  买入量: "Jumlah Beli",
  卖出价格: "Harga Jual",
  卖出量: "Jumlah Jual",
  买入: "Beli",
  卖出: "Jual",
  订单创建成功: "Pesanan Berhasil Dibuat",
  币币买入支出: "Pengeluaran Pembelian Kripto",
  币币买入支出退还: "Pengembalian Pengeluaran Pembelian Kripto",
  币币买入获得: "Kripto yang Diperoleh dari Pembelian",
  币币卖出支出: "Pengeluaran Penjualan Kripto",
  币币卖出支出退还: "Pengembalian Pengeluaran Penjualan Kripto",
  币币卖出获得: "Kripto yang Diperoleh dari Penjualan",
  币币交易手续费: "Biaya Transaksi Kripto",
  请输入限价: "Silakan Masukkan Harga Batas",
  成交: "Selesai",
  等待成交: "Menunggu Penyelesaian",
  交易完成: "Transaksi Selesai",
  被取消: "Dibatalkan",
  交易时间: "Waktu Transaksi",
  法币交易: "Perdagangan mata uang fiat",
  法币出售: "Penjualan mata uang fiat",
  两次密码不一致: "Kedua kata sandi tidak cocok",
  再次输入账户密码: "Masukkan kembali kata sandi akun",

  美国: "Amerika Serikat",
  韩国: "Korea Selatan",
  阿尔巴尼亚: "Albania",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambia",
  也门: "Yaman",
  美属维尔京群岛: "Kepulauan Virgin AS",
  英属处女群岛: "Kepulauan Virgin Britania",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistan",
  乌拉圭: "Uruguay",
  英国: "Inggris Raya",
  阿拉伯联合酋长国: "Uni Emirat Arab",
  乌克兰: "Ukraina",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Kepulauan Turks dan Caicos",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Turki",
  突尼斯: "Tunisia",
  特立尼达和多巴哥: "Trinidad dan Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Timor Leste",
  泰国: "Thailand",
  坦桑尼亚: "Tanzania",
  塔吉克斯坦: "Tajikistan",
  中国台湾: "Taiwan (Tiongkok)",
  叙利亚: "Suriah",
  瑞士: "Swiss",
  瑞典: "Swedia",
  斯威士兰: "Eswatini",
  苏里南: "Suriname",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Spanyol",
  南非: "Afrika Selatan",
  索马里: "Somalia",
  所罗门群岛: "Kepulauan Solomon",
  斯洛文尼亚: "Slovenia",
  斯洛伐克: "Slovakia",
  "圣马丁岛（荷兰部分）": "Sint Maarten (bagian Belanda)",
  新加坡: "Singapura",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychelles",
  塞尔维亚: "Serbia",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Arab Saudi",
  圣多美和普林西比: "Sao Tome dan Principe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint Kitts dan Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent dan Grenadines",
  圣彼埃尔和密克隆岛: "Saint Pierre dan Miquelon",
  圣露西亚: "Saint Lucia",
  圣基茨和尼维斯: "Saint Kitts dan Nevis",
  卢旺达: "Rwanda",
  俄罗斯: "Rusia",
  罗马尼亚: "Rumania",
  留尼汪: "Réunion",
  刚果共和国: "Republik Kongo",
  卡塔尔: "Qatar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugal",
  波兰: "Polandia",
  菲律宾: "Filipina",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua Nugini",
  巴拿马: "Panama",
  巴勒斯坦: "Palestina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norwegia",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nikaragua",
  新西兰: "Selandia Baru",
  新喀里多尼亚: "Kaledonia Baru",
  荷属安德列斯群岛: "Antillen Belanda",
  荷兰: "Belanda",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mozambik",
  摩洛哥: "Maroko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mongolia",
  摩纳哥: "Monako",
  摩尔多瓦: "Moldova",
  墨西哥: "Meksiko",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauritania",
  马里亚纳群岛: "Kepulauan Mariana",
  马提尼克: "Martinik",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maladewa",
  马来西亚: "Malaysia",
  马拉维: "Malawi",
  马达加斯加: "Madagaskar",
  马其顿: "Makedonia Utara",
  中国澳门: "Makau (Tiongkok)",
  卢森堡: "Luksemburg",
  立陶宛: "Lituania",
  列支敦士登: "Liechtenstein",
  利比亚: "Libya",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Lebanon",
  拉脱维亚: "Latvia",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgizstan",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenya",
  哈萨克斯坦: "Kazakhstan",
  约旦: "Yordania",
  日本: "Jepang",
  牙买加: "Jamaika",
  象牙海岸: "Pantai Gading",
  意大利: "Italia",
  以色列: "Israel",
  爱尔兰: "Irlandia",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonesia",
  印度: "India",
  冰岛: "Islandia",
  匈牙利: "Hungaria",
  中国香港: "Hong Kong (Tiongkok)",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinea-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Greenland",
  希腊: "Yunani",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Jerman",
  格鲁吉亚: "Georgia",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "Polinesia Prancis",
  法属圭亚那: "Guyana Prancis",
  法国: "Prancis",
  芬兰: "Finlandia",
  斐济: "Fiji",
  法罗群岛: "Kepulauan Faroe",
  埃塞俄比亚: "Etiopia",
  爱沙尼亚: "Estonia",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Guinea Khatulistiwa",
  萨尔瓦多: "El Salvador",
  埃及: "Mesir",
  厄瓜多尔: "Ekuador",
  多米尼加共和国: "Republik Dominika",
  多米尼加: "Dominika",
  吉布提: "Djibouti",
  丹麦: "Denmark",
  捷克: "Ceko",
  塞浦路斯: "Siprus",
  库拉索: "Curaçao",
  古巴: "Kuba",
  克罗地亚: "Kroasia",
  哥斯达黎加: "Kosta Rika",
  科特迪瓦: "Pantai Gading",
  库克群岛: "Kepulauan Cook",
  科摩罗: "Komoro",
  哥伦比亚: "Kolombia",
  智利: "Chili",
  乍得: "Chad",
  中非共和国: "Republik Afrika Tengah",
  佛得角: "Tanjung Verde",
  开曼群岛: "Kepulauan Cayman",
  开普: "Tanjung",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kamboja",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgaria",
  文莱: "Brunei",
  巴西: "Brasil",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnia dan Herzegovina",
  玻利维亚: "Bolivia",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgia",
  白俄罗斯: "Belarus",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesh",
  巴林: "Bahrain",
  巴哈马: "Bahama",
  阿塞拜疆: "Azerbaijan",
  奥地利: "Austria",
  澳大利亚: "Australia",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenia",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigua dan Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Samoa Amerika",
  阿尔及利亚: "Aljazair",
  中国: "Tiongkok",

  日收益: "Keuntungan Harian",
  "30天预期收益": "Keuntungan yang Diharapkan dalam 30 Hari",
  英伟达高速矿机: "Mesin Penambangan NVIDIA Berkecepatan Tinggi",
  去投资: "Mulai Berinvestasi",
  新币榜: "Daftar Mata Uang Baru",
  主题: "Tema",
  立即探索: "Jelajahi Sekarang",
  等您来: "Menunggu Anda",
  最新活动: "Aktivitas Terbaru",
  货币划转: "Transfer Mata Uang",
  提现钱包: "Dompet Penarikan Dana",
  加密合约: "Kontrak Kripto",
  外汇期货: "Futures Valuta Asing",
  定期: "Jangka Waktu Tetap",
  探索产品: "Jelajahi Produk",
  稳健型: "Tipe Konservatif",
  高收益: "Keuntungan Tinggi",
  期货账户: "Akun Futures",
  时间线: "Garis Waktu",
  收藏: "Favorit",
  委托订单: "Pesanan Dipercayakan",
  最新交易: "Transaksi Terbaru",
  深度图: "Grafik Kedalaman",
  标记价格: "Harga Tanda",
  "24h最高价": "Harga Tertinggi dalam 24 Jam",
  "24h成交量": "Volume Transaksi dalam 24 Jam",
  "24h最低价": "Harga Terendah dalam 24 Jam",
  "24h成交额": "Nilai Transaksi dalam 24 Jam",
  "价格(USDT)": "Harga (USDT)",
  "数量(ETH)": "Jumlah (ETH)",
  看空: "Posisi Pendek",
  余额不足: "Saldo Tidak Cukup",
  最低购买: "Pembelian Minimum",
  最高购买: "Pembelian Maksimum",
  下单成功: "Pesanan Berhasil Dipesan",
  平仓成功: "Penutupan Posisi Berhasil",
  请输入正确的平仓数量: "Silakan Masukkan Jumlah Penutupan Posisi yang Benar",
  加仓成功: "Penambahan Posisi Berhasil",
  请输入正确的加仓金额: "Silakan Masukkan Jumlah Penambahan Posisi yang Benar",
  收藏成功: "Berhasil Ditambahkan ke Favorit",
  取消收藏成功: "Berhasil Dihapus dari Favorit",
  日收益率: "Tingkat Keuntungan Harian",
  轻松理财: "Mengelola Keuangan dengan Mudah",
  立即申购: "Langganan Sekarang",
  申购日期: "Tanggal Langganan",
  加密货币: "Mata Uang Kripto",
  交割合约: "Kontrak Pengiriman",
  最小投资: "Investasi Minimum",
  委托: "Dipersayangkan",
  "当指数价格触达时，将会触发委托平仓":
    "Ketika harga indeks tercapai, penutupan posisi yang dipercayakan akan diaktifkan",
  预计盈利: "Keuntungan yang Diharapkan",
  最大投资: "Investasi Maksimum",
  现货交易: "Transaksi Kripto",
  输入交易金额: "Masukkan Jumlah Transaksi",
  "可用额度：": "Batas Ketersediaan:",
  提现货币: "Mata Uang Penarikan Dana",
  期货合约: "Kontrak Futures",
  加密币永续: "Perpetual kripto",
  外汇永续: "Perpetual Forex",
  期权账户: "Akun opsi",
  夜间模式: "Mode malam",
  未结盈亏: "Keuntungan dan kerugian yang belum direalisasikan",
  超额收益: "Kelebihan keuntungan",
  "安全策略，低买高卖":
    "Strategi keamanan, pembelian rendah dan penjualan tinggi",
  投资金额应为: "Jumlah investasi harus",
  总收益率: "Tingkat laba total",
  赎回成功: "Kebebasan berhasil",
  快捷卖币: "Jual koin cepat",
  修改止盈止损: "Ubah TP/SL",
  白皮书: "Buku Putih",

  托管资金: "Dana kelolaan",
  托管中: "Sedang dikelola",
  预计日收益: "Estimasi pendapatan harian",
  累计收益: "Total pendapatan",
  周期: "Periode",
  日收益: "Pendapatan harian",
  限额: "Batas",
  立即托管: "Investasi sekarang",
  "已鎖定 請聯繫客服": "Terkunci, silakan hubungi layanan pelanggan",
  产品列表: "Daftar produk",
  规则: "Aturan",
  创建订单: "Buat pesanan",
  产品名称: "Nama produk",
  托管周期: "Periode pengelolaan",
  等级限制: "Batasan level",
  托管金额: "Jumlah investasi",
  限额: "Batas",
  余额: "Saldo",
  购买日: "Tanggal pembelian",
  起息日: "Tanggal mulai bunga",
  派息时间: "Waktu pembagian keuntungan",
  每天: "Setiap hari",
  计息结束日: "Tanggal akhir bunga",
  每日收益: "Pendapatan harian",
  预计收益: "Perkiraan pendapatan",
  "收益将自动发送至您的余额账户;":
    "Keuntungan akan otomatis dikirim ke akun saldo Anda;",
  "您的资金没有任何风险;": "Dana Anda tidak memiliki risiko apa pun;",
  "365*24小时不断地工作;": "Bekerja 24 jam sehari, 365 hari setahun;",
  托管中: "Sedang dikelola",
  结束: "Selesai",
  今日收益: "Pendapatan hari ini",
  剩余周期: "Sisa periode",
  进行中: "Sedang berlangsung",
  已发放: "Sudah dibayarkan",
  信誉分: "Poin reputasi",

  复制成功: "Berhasil disalin",
  VIP权益: "Keuntungan VIP",
  旧密码: "Kata sandi lama",
  请输入旧密码: "Masukkan kata sandi lama",
  "忘记旧密码请联系客服重置。":
    "Jika Anda lupa kata sandi lama, silakan hubungi layanan pelanggan untuk meresetnya.",
  去升级: "Tingkatkan",
  描述: "Deskripsi",
  实际存款金额: "Jumlah deposit aktual",
  升级礼金: "Bonus peningkatan",
  隔夜利息: "Bunga semalam (swap)",
  自动结算: "Penyelesaian otomatis",
  等级规则: "Aturan level",
  "WEB3.0币持有数据收益": "Imbal hasil data kepemilikan koin WEB3.0",
  总生产: "Total produksi",
  有效节点: "Node aktif",
  参与人: "Peserta",
  用户收益: "Imbal hasil pengguna",
  "流动性WEB3.0输出": "Output likuiditas WEB3.0",
  总资产: "Total aset",

  ETHAI持有数据收益: "Imbal Hasil Data Kepemilikan ETHAI",
  AI量化流动性: "Likuiditas Kuantitatif AI",
  现货买入手续费: "Biaya Beli Spot",
  现货支出: "Pengeluaran Spot",
  现货资金费率: "Tingkat Pendanaan Spot",
  现货卖出手续费: "Biaya Jual Spot",
  现货收入: "Pendapatan Spot",
  外汇合约支出: "Pengeluaran Kontrak Valas",
  外汇合约买入手续费: "Biaya Beli Kontrak Valas",
  外汇合约资金费率: "Tingkat Pendanaan Kontrak Valas",
  外汇合约卖出手续费: "Biaya Jual Kontrak Valas",
  外汇合约收入: "Pendapatan Kontrak Valas",
  理财购买: "Pembelian Produk Keuangan",
  VIP理财日收益: "Imbal Hasil Harian Produk Keuangan VIP",
  VIP理财隔夜利息: "Bunga Semalam Produk Keuangan VIP",
  VIP本金返还: "Pengembalian Pokok VIP",
  VIP彩金发放: "Pembagian Bonus VIP",
  VIP彩金抵扣: "Pengurangan Bonus VIP",
  隔夜利息: "Bunga Semalam",
  设置资产密码: "Atur Kata Sandi Aset",
  锁仓挖矿: "Penambangan dengan penguncian",
  一站式理财服务: "Layanan keuangan satu pintu",
  产品: "Produk",
  客服中心: "Pusat layanan pelanggan",
  贷款: "Pinjaman",
  挖矿赚不停: "Penghasilan mining tanpa henti",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Penambangan dengan penguncian adalah dengan menitipkan USDT (USD:1USDT=1USD) ke mesin mining berdaya komputasi tinggi milik platform untuk mendapatkan keuntungan di pool mining platform.",
  产品优势: "Keunggulan produk",
  随存随取: "Bisa setor dan tarik kapan saja",
  锁仓周期: "Periode penguncian",
  每日下发: "Distribusi harian",
  随机空投: "Airdrop acak",
  "100%资金安全保障": "100% jaminan keamanan dana",
  "100%节假日收益不间断": "100% keuntungan tetap berjalan saat hari libur",
  成功锁仓后当天产出:
    "Menghasilkan pada hari yang sama setelah penguncian berhasil",
  关于违约金: "Tentang penalti",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Jika Anda ingin menarik pokok sebelum jatuh tempo, akan dikenakan penalti. Penalti = persentase penalti × sisa hari × jumlah yang dikunci.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Contoh: Rasio penalti penambangan dengan penguncian ini adalah 5%, sisa 3 hari hingga jatuh tempo, dan jumlah yang dikunci adalah 10000U (USDT/USD). Maka penalti = 5%×3×10000=1500U, dan pokok yang dikembalikan adalah 15000U-1500U.",
  收益计算: "Perhitungan keuntungan",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Platform menyediakan berbagai produk keuangan penambangan dengan penguncian untuk dipilih pengguna. Perhitungan keuntungan sebagai berikut, misalnya:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Jika anggota mengunci 10000U (USDT, USD) di platform dan memilih produk 7 hari dengan hasil harian 0,7%~1,8% dari jumlah yang dikunci, maka hasil harian adalah sebagai berikut:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maksimum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Setelah 7 hari, Anda dapat memperoleh keuntungan 490U~1260U. Keuntungan dibagikan setiap hari, dan pokok yang dikunci akan otomatis masuk ke akun dana Anda setelah jatuh tempo.",
  正在托管的资金: "Dana yang dikelola",
  签到: "Check-in",
  锁仓订单: "Pesanan penguncian",
  预计今日收益: "Estimasi keuntungan hari ini",
  累计收益: "Keuntungan kumulatif",
  托管中的订单: "Pesanan dalam pengelolaan",
  单笔最少: "Minimum per transaksi",
  单笔最多: "Maksimum per transaksi",
  日收益率: "Tingkat keuntungan harian",
  说明: "Penjelasan",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Waktu statistik berdasarkan GMT+8<br>2. Keuntungan harian dihitung berdasarkan semua pesanan yang sudah diselesaikan antara 00:00-23:59 GMT+8 (waktu lokal 00:00-23:59)<br>3. Keuntungan hari itu akan dibagikan pada hari berikutnya antara 00:00-00:10 GMT+8.",
  知道了: "Mengerti",
  锁仓: "Kunci",
  派息时间: "Waktu distribusi",
  每日: "Harian",
  托管资金: "Dana kustodian",
  到期返回: "Kembali saat jatuh tempo",
  提前赎回: "Penarikan awal",
  预计收益: "Perkiraan keuntungan",
  认购: "Berlangganan",
  热门: "Populer",
  数字货币: "Mata uang kripto",
  贵金属: "Logam mulia",
  大宗商品: "Komoditas",
  持仓明细: "Detail posisi",
  历史明细: "Riwayat",
  当前价: "Harga saat ini",
  "↑买涨": "↑ Beli naik",
  "↓买跌": "↓ Beli turun",
  显示全部: "Tampilkan semua",
  买入金额: "Jumlah pembelian",
  方向: "Arah",
  收益: "Keuntungan",
  预期收益: "Perkiraan keuntungan",
  估用保证金: "Perkiraan margin",
  确认下单: "Konfirmasi pesanan",
  锁定: "Terkunci",
  账户总资产: "Total aset akun",
  明细: "Detail",
  今日收益: "Keuntungan hari ini",
  仓位保证金: "Margin posisi",
  持有仓位: "Posisi terbuka",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Jumlah terkunci = total semua pesanan penambangan dengan penguncian yang belum selesai",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Waktu statistik berdasarkan GMT+8<br>2. Keuntungan harian dihitung berdasarkan semua pesanan yang sudah diselesaikan antara 00:00-23:59 GMT+8 (waktu lokal 00:00-23:59)",
  充值方式: "Metode deposit",
  银行汇款: "Transfer bank",
  "银行汇款请联系客服进行操作!":
    "Silakan hubungi layanan pelanggan untuk transfer bank!",
  提款方式: "Metode penarikan",
  "银行提款请联系客服进行操作!":
    "Silakan hubungi layanan pelanggan untuk penarikan bank!",
  资金明细: "Detail dana",
  提现记录: "Riwayat penarikan",
  拒绝: "Ditolak",
  通过: "Disetujui",
  拒绝原因: "Alasan penolakan",

  消息公告: "Pengumuman",
  订单: "Pesanan",
  个人中心: "Pusat pribadi",
  "未到期赎回需支付一定的违约金!":
    "Penebusan sebelum jatuh tempo dikenakan biaya penalti.",

  请输入区号: "Silakan masukkan kode area",
  "请选择国家/地区": "Silakan pilih negara/wilayah",

  今日开盘: "Pembukaan hari ini",
  昨日收盘: "Penutupan kemarin",

  实名认证即送: "Dapatkan segera setelah verifikasi identitas",
  立即认证: "Verifikasi Sekarang",
  新用户礼包: "Paket Hadiah Pengguna Baru",
  完成新人任务领取: "Selesaikan tugas pengguna baru untuk mengklaim",
  认证: "Verifikasi",
  时间周期: "Periode Waktu",
  支付金额: "Jumlah Pembayaran",
  已平仓: "Sudah Ditutup",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Paket Sambutan Pengguna Baru MGBX: Setiap pengguna dapat menerima maksimal",
  我已经阅读并同意: "Saya telah membaca dan menyetujui",
  隐私政策: "Kebijakan Privasi",

  放弃奖励离开: "Tinggalkan hadiah dan keluar",
  继续注册: "Lanjutkan pendaftaran",
  分钟: "Menit",

  "请先勾选隐私政策!": "Silakan periksa Kebijakan Privasi terlebih dahulu!",

  添加其他到自选: "Tambahkan yang lain ke Daftar Pantauan",

  充值最高可得: "Lakukan isi ulang dan dapatkan hingga $30.000.",

  请输入格式正确的手机号: "Silakan masukkan nomor ponsel yang valid.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 印尼语



// WEBPACK FOOTER //
// ./src/lang/id.js